import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';

import ToggleArrow from 'components/ToggleArrow/ToggleArrow';

import './CollapsibleList.scss';

const b = block('CollapsibleList');

export default class CollapsibleList extends React.Component {
    static propTypes = {
        arrowPosition: PropTypes.oneOf(['left', 'right']),
        isTitle: PropTypes.bool,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
            }),
        ),
        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    };

    static defaultProps = {
        arrowPosition: 'left',
        isTitle: false,
        items: [],
    };

    constructor(props) {
        super(props);

        this.contentRefs = {};
        this.state = {
            initialized: false,
            opened: {},
            heights: {},
        };
    }

    componentDidMount() {
        const heights = Object.keys(this.contentRefs).reduce((acc, key) => {
            acc[key] = this.contentRefs[key].offsetHeight;
            return acc;
        }, {});

        this.setState({heights, initialized: true});
    }

    getOpenState(key) {
        const {opened} = this.state;
        const value = opened[key];

        return typeof value === 'boolean' ? value : false;
    }

    getContentHeight(key) {
        const {opened, heights} = this.state;

        if (opened[key]) {
            return heights[key];
        }

        return 0;
    }

    toggleOpen(key) {
        this.setState((prevState) => {
            const prevOpened = prevState.opened[key];

            return {
                opened: {
                    ...prevState.opened,
                    [key]: !prevOpened,
                },
            };
        });
    }

    getElementParams(index) {
        const {initialized} = this.state;
        const key = index;
        const open = this.getOpenState(key);
        const openTitle = open ? 'opened' : 'closed';
        const state = initialized ? openTitle : 'preparing';
        const ref = (data) => {
            this.contentRefs[key] = data;
        };
        const contentStyle = {height: initialized ? this.getContentHeight(key) : 'auto'};

        return {
            key,
            open,
            state,
            ref,
            contentStyle,
        };
    }

    renderElementWrap(element, {title, extra = '', key, open, state, ref, contentStyle}) {
        const {isTitle, arrowPosition} = this.props;
        return (
            <li key={key} className={b('item', {state, ['with-border']: isTitle})}>
                <div className={b('header')}>
                    <div className={b('header-left')}>
                        <button
                            className={b('toggle', {position: arrowPosition})}
                            onClick={this.toggleOpen.bind(this, key)}
                        >
                            <ToggleArrow
                                className={b('toggle-arrow', {size: isTitle ? 'm' : 's'})}
                                open={open}
                                slow={true}
                                size={isTitle ? 20 : 18}
                                thin={!isTitle}
                                type={arrowPosition === 'right' ? 'vertical' : 'horizontal'}
                            />
                            {React.createElement(
                                isTitle ? 'h4' : 'h5',
                                {className: b('title')},
                                <HTML>{title}</HTML>,
                            )}
                        </button>
                    </div>
                    <div className={b('header-right')}>{extra}</div>
                </div>
                <div ref={ref} style={contentStyle} className={b('content')}>
                    {element}
                </div>
            </li>
        );
    }

    renderChildren() {
        const {children} = this.props;

        return React.Children.map(children, (child, index) => {
            if (child) {
                return this.renderElementWrap(
                    <div className={b('text')}>{React.Children.toArray(children)[index]}</div>,
                    {
                        title: child.props.title,
                        extra: child.props.extra,
                        ...this.getElementParams(index),
                    },
                );
            }

            return null;
        });
    }

    renderDescription() {
        const {items} = this.props;

        return items.map(({title, description}, index) => {
            return this.renderElementWrap(
                <p className={b('text')}>
                    <HTML>{description}</HTML>
                </p>,
                {
                    title: title,
                    ...this.getElementParams(index),
                },
            );
        });
    }

    render() {
        const {children} = this.props;

        return (
            <ul className={b()}>{children ? this.renderChildren() : this.renderDescription()}</ul>
        );
    }
}
